import PropTypes from 'prop-types'

function CheckboxFilter({ name, label, checked, handleFilter, setSearchingHousetrained }) {
  const handleChange = (e) => {
    handleFilter(name, e.target.checked ? '1' : '')
    setSearchingHousetrained(e.target.checked)
  }

  return (
    <div className="field checkbox">
      <input id={name} type="checkbox" name={name} value="1" checked={checked} onChange={handleChange} />
      <label htmlFor={name}>{label}</label>
    </div>
  )
}

CheckboxFilter.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  handleFilter: PropTypes.func,
  setSearchingHousetrained: PropTypes.func,
}

export default CheckboxFilter
